<template>
  <teleport to="body">
    <div class="fixed top-4 right-4 z-[60] flex flex-col gap-3 w-80 pointer-events-none">
      <transition-group
        enter-active-class="transition duration-300"
        enter-from-class="opacity-0 translate-x-8"
        enter-to-class="opacity-100 translate-x-0"
        leave-active-class="transition duration-200"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0 translate-x-8"
      >
        <div
          v-for="toast in toasts"
          :key="toast.id"
          class="pointer-events-auto bg-white rounded-xl shadow-lg border border-neutral-100 flex items-start gap-3 p-4 overflow-hidden"
          :class="toast.type === 'success' ? 'border-l-4 border-l-success-500' : 'border-l-4 border-l-error-500'"
        >
          <!-- Icon -->
          <div class="flex-shrink-0 mt-0.5">
            <svg v-if="toast.type === 'success'" class="w-5 h-5 text-success-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <svg v-else class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          <!-- Message -->
          <p class="text-sm text-neutral-700 flex-1 leading-snug">{{ toast.message }}</p>

          <!-- Dismiss -->
          <button
            @click="dismiss(toast.id)"
            class="flex-shrink-0 text-neutral-400 hover:text-neutral-600 transition-colors"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </transition-group>
    </div>
  </teleport>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useToast } from '@/composables/useToast'

export default defineComponent({
  name: 'BaseToast',
  setup () {
    const { toasts, dismiss } = useToast()
    return { toasts, dismiss }
  }
})
</script>
